
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorPistonInleftLeft75 as ObiThreewayAcuatorPistonInleftLeft75Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-piston-inleft-left-75.js';
 
 
 

 
 export const ObiThreewayAcuatorPistonInleftLeft75 = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-piston-inleft-left-75',
   elementClass: ObiThreewayAcuatorPistonInleftLeft75Element,
   events: {
     
   }
  });
 
 